export default "__VITE_ASSET__BySxRdqp__"